import loadable from '@loadable/component'

export const ESGKey = loadable(() => import('./ESGKey'))
export const ESGKeyWithRatingKey = loadable(
  () => import('./ESGKeyWithRatingKey')
)
export type { ESGKeyWithRatingKeyProps } from './ESGKeyWithRatingKey'
